import { debounce } from "./utils.js";

export function hideBlocksWithResults() {
  if (!localStorage.getItem("g_octane_results")) return;

  document.querySelectorAll(".js-hide-if-results").forEach((el) => {
    el.style.display = "none";
  });
}

export function replaceDiagnosticLinks() {
  if (!localStorage.getItem("g_octane_results")) return;

  const targetHref = "/pages/diagnostic/results?view=quiz-results";
  const targetText = "Quiz Results"; 
  const hrefCandidates = new Set(["/pages/diagnostic", "/pages/diagnostic/"]);
  const allowedContainerSelectors = [".header-menu-item"];

  /** @param {Element} link */
  const isInsideAllowedContainer = (link) => {
    return allowedContainerSelectors.some((selector) => {
      try {
        return Boolean(link.closest(selector));
      } catch (_error) {
        return false;
      }
    });
  };

  /** @param {HTMLAnchorElement} link */
  const shouldReplaceHref = (link) => {
    const rawHref = (link.getAttribute("href") || "").trim();
    if (hrefCandidates.has(rawHref)) return true;

    try {
      const parsed = new URL(link.href, window.location.origin);
      return hrefCandidates.has(parsed.pathname);
    } catch (_error) {
      return false;
    }
  };

  /** @param {HTMLAnchorElement} link */
  const applyToLink = (link) => {
    if (!isInsideAllowedContainer(link)) return;
    if (!shouldReplaceHref(link)) return;
    link.setAttribute("href", targetHref);
    link.textContent = targetText;
  };

  /** @param {Node} node */
  const applyToNode = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches("a[href]")) {
      applyToLink(/** @type {HTMLAnchorElement} */ (node));
    }
    node
      .querySelectorAll?.("a[href]")
      .forEach((link) => applyToLink(/** @type {HTMLAnchorElement} */ (link)));
  };

  const applyToMatchingLinks = () => {
    document.querySelectorAll("a[href]").forEach((link) =>
      applyToLink(/** @type {HTMLAnchorElement} */ (link)),
    );
  };

  applyToMatchingLinks();

  const handleMutations = debounce(
    /** @param {MutationRecord[]} mutations */ (mutations) => {
      mutations.forEach(
        /** @param {MutationRecord} mutation */ (mutation) => {
          mutation.addedNodes.forEach(/** @param {Node} node */ (node) => {
            applyToNode(node);
          });
        },
      );
    },
  );
  const observer = new MutationObserver(handleMutations);
  observer.observe(document.body, { childList: true, subtree: true });
}
